module.exports = __webpack_public_path__ + "cloud.1b360202.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/content/cloud.svg
 ** module id = 107
 ** module chunks = 0
 **/